import {
  Component, Input, Output, EventEmitter, ChangeDetectionStrategy,
} from '@angular/core';
import { CatalogCourseTrack, CourseCardStatus } from '../../models';

@Component({
  selector: 'ut-academy-course-card',
  templateUrl: './academy-course-card.component.html',
  styleUrls: ['./academy-course-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcademyCourseCardComponent {
  @Input() courseTrack!: CatalogCourseTrack;
  @Input() status: CourseCardStatus = 'not-started';
  @Output() courseClick = new EventEmitter<number>();

  onButtonClick(): void {
    if (this.isLocked) return;
    this.courseClick.emit(this.courseTrack.id);
  }

  get badgeStatus(): string {
    return this.status === 'locked' ? 'not-started' : this.status;
  }

  get statusLabel(): string {
    switch (this.status) {
      case 'completed': return 'Completed';
      case 'in-progress': return 'In Progress';
      default: return 'Not Started';
    }
  }

  get buttonLabel(): string {
    switch (this.status) {
      case 'completed': return 'Review Course';
      case 'in-progress': return 'Resume Course';
      default: return 'Start Course';
    }
  }

  get isLocked(): boolean {
    return this.status === 'locked';
  }

  get isPrimary(): boolean {
    return this.status === 'not-started' || this.status === 'in-progress';
  }

  get ariaLabel(): string {
    return `${this.courseTrack.name} - ${this.statusLabel}`;
  }
}
